import { getWebSocketUrl as getEnvWebSocketUrl } from '../config/environment'

export let wsConnection = null;

const getWebSocketUrl = () => {
  // Use WS_URL from environment configuration (loaded from .env file)
  const wsUrl = getEnvWebSocketUrl()
  if (!wsUrl) {
    console.error('❌ WS_URL not found in .env file. Please create .env file with WS_URL variable.')
  }
  return wsUrl
};

export async function createConnection() {
  console.log('Starting connection to WebSocket Server', wsConnection);

  if (!wsConnection || wsConnection.readyState === WebSocket.CLOSED) {
    const webSocketUrl = getWebSocketUrl();
    wsConnection = new WebSocket(webSocketUrl);

    wsConnection.onopen = () => {
      console.log('WebSocket connection established.');
    };

    wsConnection.onclose = (evt) => {
      console.log('WebSocket closed:', evt);
      wsConnection = null;
    };

    wsConnection.onerror = (evt) => {
      console.error('WebSocket error:', evt);
    };
  }
}

export const openSocket = () => {
  return wsConnection ? wsConnection.readyState : WebSocket.CLOSED;
};

export const sendRequest = async (obj) => {
  if (openSocket() !== WebSocket.OPEN) {
    await createConnection();
    setTimeout(() => {
      if (wsConnection.readyState === WebSocket.OPEN) {
        wsConnection.send(obj);
      } else {
        console.log('WebSocket is not open. Cannot send message.');
      }
    }, 1000); // Consider implementing a more robust retry mechanism instead
  } else {
    wsConnection.send(obj);
  }
};

export const sendRunnerDataMsg = (data) => {
  return sendRequest(JSON.stringify(data));
};



// WEBPACK FOOTER //
// ./src/services/webSocket.js